import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './AddButton.module.css';

interface AddButtonProps {
  onClick: () => void;
  label?: string;
}

export const AddButton = ({ onClick, label }: AddButtonProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.button}
      aria-label={label ?? t('header.add', 'Add')}
    >
      <Plus size={20} />
      <span>{label ?? t('header.add', 'Add')}</span>
    </button>
  );
};
